import axios from 'axios'
import { handleLocalStorage } from '@/utils/handleLocalStorage.js'
import router from '@/router'
import { Message } from 'view-design'
import Loading from './loading/loading.js'
import qs from 'qs'
import store from '@/store'

const axiosInstance = axios.create({
  // 设置请求基地址、超时时间和请求头
  baseURL: '/docking',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
})

// http请求数
let requestCount = 0

// 不需要token的接口
const doNotNeedToken = {
  FixedApi: [ // 固定的接口名称
    '/api/login',
    '/api/model/open/model',
    '/api/wechat/getUserInfo',
    '/api/file/open/upload',
    '/api/bullet/bullet',
    '/api/bullet/pageParam',
    '/api/website/queryAll',
    '/api/website/recommend/page',
    '/api/website/getPhone',
    '/api/website/modelApply/save',
    '/api/website/editPass',
    '/api/website/recommendModel',
    '/api/experienceModel/query',
    '/api/carouselChart/page',
    '/api/selectionCases/page',
    '/api/carouselChart/getIsShow',
    '/api/wechat/getSignature',
    '/api/shareClues/save',
    '/api/sys/permutationToken',
    '/api/dataCollect/create',
    '/api/sys/centerCheckPhone'

  ],
  ChangeableApi: [ // 会变动的接口，即url后面会拼接一些字符，也可以写入文件名（例如setting.json）
    '/api/model/visit',
    '/data/models',
    '/api/register/accountStatus',
    '/api/register/sms/code',
    '/api/website/sms/code',
    '/api/register',
    '/api/website/appointment',
    'https://restapi.amap.com/v3/geocode/geo' // 地图
  ]
}

// 报错后不需要返回到登录页的接口
const doNotgoBackLogin = {
  FixedApi: [
    '/api/wechat/getUserInfo',
    '/api/file/open/upload',
    '/api/bullet/bullet',
    '/api/bullet/pageParam'
  ],
  ChangeableApi: []
}

// 文件上传接口，需要重写请求转换器的
const fileUploadApi = [
  '/api/file/file/upload',
  '/api/file/open/upload',
  '/api/document/upload'
]

// 请求拦截器
axiosInstance.interceptors.request.use(
  config => {
    // 加载动画
    requestCount++

    // 开启loading请求效果
    if (config.isLoading) {
      Loading('loading')
    }

    // console.log(123,config.url,isNeedToken(config.url))
    // 判断是不是需要token
    if (isNeedToken(config.url)) {
      // 刷新token，用于到服务端换取新token
      config.headers['RefreshAuthorization'] = handleLocalStorage.getSomeItem('refreshToken')

      const token = handleLocalStorage.getTokenItem()
      // 发送请求前判断是否存在token，有则加上token
      if (!!token) config.headers.Authorization = 'Bearer ' + token
      else { // 没有token，跳到登录页
        router.push('/')
        return Promise.reject(new Error('请求失败，请登录'))
      }
    }

    if (config.method === 'get') {
      config.paramsSerializer = params => qs.stringify(params, { arrayFormat: 'repeat' })
    }

    if (fileUploadApi.includes(config.url)) {
      // 重写请求转换器
      config.transformRequest = [data => handleFile(data)]
    }
    return config
  },
  error => {
    // 请求超时处理
    if (--requestCount === 0) {
      Loading('overtime')
    }

    return Promise.error(error)
  }
)

// 响应拦截器
axiosInstance.interceptors.response.use(
  response => {
    // 去掉加载动画
    if (--requestCount === 0) {
      Loading('close')
    }
    // 更新token
    response.headers.authorization && handleLocalStorage.setTokenItem(response.headers.authorization)

    // status === '1' 是获取地图的响应成功码
    if (response.data.status === 200 || response.data.status === '1' || response.data.code === 0 ||response.data.code == 200) {
      return Promise.resolve(response)
    } else if (response.data.status === 400 || response.data.status === 500) {
      // 用户名密码错误
      Message.warning(response.data.msg)
      return Promise.reject(response)
    } else {
      // Message.warning(response.data.msg)
      return Promise.reject(response)
    }
  },
  error => {
    // 连接失败处理
    if (--requestCount === 0) {
      Loading('close')
    }

    if (error.response) { // 从服务端返回的
      if (error.response.status === 403 && error.response.data.status === 500) {
        Message.warning('账户权限不足')
      }
      if (error.response.status === 403 && error.response.data.status === 403) {
        if (isNeedGobackLogin(error.config.url)) {
          Message.error('账户过期或失效,请重新登录')
          // handleLocalStorage.removeTokenItem()
          store.dispatch('user/logout') // 退出登录，移除相关缓存数据
          router.push('/')
        } else {
          Message.error('认证失败')
        }
      }
      if (error.response.status === 500 || error.response.status === 400) {
        Message.info("连接失败，请稍后重试")
      }
    }

    return Promise.reject(error)
  }
)

/*
 *@description:
 *@author: show
 *@date: 2020-12-28 15:15:52
 *@version: V1.0
*/
const http = function (url, data = {}, method = 'GET', isLoading = true) {
  return new Promise((resolve, reject) => {
    sendRequest(url, data, method, isLoading, resolve, reject)
  })
}

/*
 *@description:
 *@author: show
 *@date: 2020-12-28 15:16:59
 *@version: V1.0
*/
const sendRequest = (url, data, method, isLoading, resolve, reject) => {
  axiosInstance({
    method: method,
    url: url,
    isLoading,
    [method.toLocaleLowerCase() === 'get' ? 'params' : 'data']: data
  }).then(res => {
    resolve(res)
  }).catch(err => {
    reject(err)
  })
}

/*
 *@functionName: handleFile
 *@params1: data
 *@return: object
 *@description: 处理文件上传的数据
 *@author: show
 *@date: 2021-01-05 17:15:02
 *@version: V1.0
*/
const handleFile = (data) => {
  const formDataObj = new FormData()
  for (const item in data) {
    formDataObj.append(item, data[item])
  }
  return formDataObj
}

/*
 *@functionName: isNeedToken
 *@params1: url
 *@return: Boolean
 *@description: 查看api请求是否需要携带token的接口
 *@author: show
 *@date: 2021-01-05 10:30:02
 *@version: V1.0
*/
const isNeedToken = (url) => {
  if (doNotNeedToken.FixedApi.includes(url)) return false

  for (const item of doNotNeedToken.ChangeableApi) if (url.search(item) !== -1) return false

  return true
}

/*
 *@functionName: isNeedGobackLogin
 *@params1: url
 *@return: Boolean
 *@description: 查看api请求403后是否需要返回登录页并移除token
 *@author: dandan
 *@date: 2021-01-26 16:29:34
 *@version: V1.0
*/
const isNeedGobackLogin = (url) => {
  if (doNotgoBackLogin.FixedApi.includes(url)) return false

  for (const item of doNotgoBackLogin.ChangeableApi) if (url.search(item) !== -1) return false

  return true
}

export default http
